import React from 'react';
import { useLocation } from 'react-router';
import { PERSONAL_LOAN_PAGE_ROUTE } from '../../data/routes-constants';

const Faq = () => {
  const location = useLocation();
  const isPersonalLoanPage = location.pathname === PERSONAL_LOAN_PAGE_ROUTE;

  const renderFAQs = () => {
    if (isPersonalLoanPage) {
      return (
        <>
          <div className="card">
            <div className="card-header" id="faqhead1">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq1"
                aria-expanded="true"
                aria-controls="faq1">
                What is a personal loan?
              </a>
            </div>
            <div
              id="faq1"
              className="collapse"
              aria-labelledby="faqhead1"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  A personal loan is a type of unsecured loan that you can use
                  for various personal expenses such as home renovations,
                  medical bills, vacations, or consolidating debt. Unlike a
                  mortgage or car loan, a personal loan is not secured against
                  any asset.
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="faqhead2">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq2"
                aria-expanded="true"
                aria-controls="faq2">
                How can I apply for a personal loan with Dotpe Cappitals?
              </a>
            </div>
            <div
              id="faq2"
              className="collapse"
              aria-labelledby="faqhead2"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  You can apply for a personal loan through our website by
                  filling out the online application form.
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="faqhead3">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq3"
                aria-expanded="true"
                aria-controls="faq3">
                What are the eligibility criteria for a personal loan?
              </a>
            </div>
            <div
              id="faq3"
              className="collapse"
              aria-labelledby="faqhead3"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  To be eligible for a personal loan, you generally need to be
                  at least 18 years old, have a steady source of income, and
                  meet our credit score requirements. Specific eligibility
                  criteria may vary, so please check our website or contact our
                  customer service for more details.
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="faqhead4">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq4"
                aria-expanded="true"
                aria-controls="faq4">
                What is the interest rate for a personal loan?
              </a>
            </div>
            <div
              id="faq4"
              className="collapse"
              aria-labelledby="faqhead4"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  Interest rates for personal loans vary based on your credit
                  profile, loan amount, and loan term. We offer competitive
                  rates, and you can check your personalized rate by applying
                  online or contacting us.
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="faqhead5">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq5"
                aria-expanded="true"
                aria-controls="faq5">
                How long does it take to get approved?
              </a>
            </div>
            <div
              id="faq5"
              className="collapse"
              aria-labelledby="faqhead5"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  The approval process for a personal loan can take anywhere
                  between a few hours to a few days after we receive all the
                  necessary documents. In some cases, it may take longer
                  depending on the complexity of your application.
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header" id="faqhead6">
              <a
                href="#"
                className="btn btn-header-link collapsed"
                data-toggle="collapse"
                data-target="#faq6"
                aria-expanded="true"
                aria-controls="faq6">
                What documents do I need to apply for a personal loan?
              </a>
            </div>
            <div
              id="faq6"
              className="collapse"
              aria-labelledby="faqhead6"
              data-parent="#faq">
              <div className="card-body tw-pointer-events-none tw-select-none">
                <p>
                  Commonly required documents include proof of identity (such as
                  a passport or driver's license), proof of income (such as
                  salary slip or tax returns), and proof of residence (such as a
                  utility bill). Additional documents may be required based on
                  your individual application.
                </p>
              </div>
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="card">
          <div className="card-header" id="faqhead5">
            <a
              href="#"
              className="btn btn-header-link"
              data-toggle="collapse"
              data-target="#faq4"
              aria-expanded="true"
              aria-controls="faq4">
              Why should I choose DotPe Cappitals?
            </a>
          </div>
          <div
            id="faq4"
            className="collapse show"
            aria-labelledby="faqhead4"
            data-parent="#faq">
            <div className="card-body tw-pointer-events-none tw-select-none">
              <p>
                We quickly check your eligibility to map you to the right lender
                and get you a loan fast, with great rates and flexible terms
                just a click away for financial help! Our goal is to help you
                grow.
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="faqhead5">
            <a
              href="#"
              className="btn btn-header-link collapsed"
              data-toggle="collapse"
              data-target="#faq5"
              aria-expanded="true"
              aria-controls="faq5">
              What products can I choose with DotPe Cappitals?
            </a>
          </div>

          <div
            id="faq5"
            className="collapse"
            aria-labelledby="faqhead5"
            data-parent="#faq">
            <div className="card-body tw-pointer-events-none tw-select-none">
              <p>
                You can choose from a pool of products ranging from business
                loans, personal loans etc. This is not it, we are continuously
                working towards providing you with more and more lending
                options.
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="faqhead6">
            <a
              href="#"
              className="btn btn-header-link collapsed"
              data-toggle="collapse"
              data-target="#faq6"
              aria-expanded="true"
              aria-controls="faq6">
              How can I apply for a loan?
            </a>
          </div>

          <div
            id="faq6"
            className="collapse"
            aria-labelledby="faqhead6"
            data-parent="#faq">
            <div className="card-body tw-pointer-events-none tw-select-none">
              <p>
                You can request a loan by following these simple steps:
                <ul>
                  <li>
                    1. <strong>Show your Interest:</strong> Forget lengthy forms
                    and wait for quotes. Tell us your loan needs, and we will do
                    the heavy lifting.
                  </li>
                  <li>
                    2.{' '}
                    <strong>
                      Smart Matching with the lowest interest rate and a high
                      Success Rate:
                    </strong>{' '}
                    Our experts analyze your details and match you with the best
                    banks from our network of lenders.
                  </li>
                  <li>
                    3. <strong>Loan Disbursal on Successful Approval:</strong>{' '}
                    The entire process is streamlined to take minutes, not
                    weeks. You'll know where you stand quickly and can access
                    your funds faster to achieve your goals.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="faqhead7">
            <a
              href="#"
              className="btn btn-header-link collapsed"
              data-toggle="collapse"
              data-target="#faq7"
              aria-expanded="true"
              aria-controls="faq7">
              Will I have to put a collateral as security to get a loan?
            </a>
          </div>

          <div
            id="faq7"
            className="collapse"
            aria-labelledby="faqhead7"
            data-parent="#faq">
            <div className="card-body tw-pointer-events-none tw-select-none">
              <p>
                DotPe Cappitals offers both unsecured loans where collateral is
                not required and secured loans where collateral is required.
              </p>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="faqhead8">
            <a
              href="#"
              className="btn btn-header-link collapsed"
              data-toggle="collapse"
              data-target="#faq8"
              aria-expanded="true"
              aria-controls="faq8">
              Does DotPe offer part-time opportunities in return for payment?
            </a>
          </div>

          <div
            id="faq8"
            className="collapse"
            aria-labelledby="faqhead8"
            data-parent="#faq">
            <div className="card-body tw-pointer-events-none tw-select-none">
              <p>
                Please be advised that DotPe does not engage in such
                recruitment.
              </p>
              <p>
                We urge all users to exercise caution and avoid sharing personal
                information, payment details, or making any financial
                transactions in response to unsolicited job offers or
                opportunities claiming to be from <strong>DotPe.</strong>
              </p>
              <p>
                You can request a loan by following these simple steps:
                <ul>
                  <li>
                    <strong>Official Communication:</strong> All genuine
                    opportunities or updates from DotPe are shared through our
                    official website or verified communication channels.
                  </li>
                  <li>
                    <strong>No Upfront Payments:</strong> We never ask for any
                    fees or payments for job applications, interviews, or
                    training.
                  </li>
                  <li>
                    <strong>Verify Sources:</strong> If you receive any
                    suspicious communication, please verify its authenticity by
                    contacting us directly through our official website or
                    customer support.
                  </li>
                </ul>
              </p>
              <p>
                <strong>DotPe</strong> will not be responsible for any financial
                loss or damage caused by fraudulent activities or scams misusing
                our brand name. Stay vigilant and report any suspicious activity
                to the appropriate authorities.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <section className="sec-8 tw-bg-[#ffffff]">
      <div className="container">
        {/* <h2 className="subheading">Frequently Asked Questions</h2> */}
        <div className="dc_hdgtitle tw-pointer-events-none tw-select-none">
          Frequently Asked
          <br /> Questions
        </div>
        <div className="row mid">
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="accordion" id="faq">
              {renderFAQs()}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
